<div class="dialog-content-min">
  <form [formGroup]="groupForm">
    <div class="formgrid grid m-2">
      <div class="field col-12">
        <label for="groupname">
          Client Group Name<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 100
            chars) </span><span class="required-label">*</span>
        </label>
        <input type="text" class="form-control" placeholder="Enter Name" id="groupname" formControlName="groupname"
          required name="groupname" pInputText>
        <span class="errormessage"
          *ngIf="groupForm.get('groupname').invalid && (groupForm.get('groupname').dirty || groupForm.get('groupname').touched)">
          {{getErrorMessage(groupForm ,validation_message,'groupname')}}
        </span>
      </div>
    </div>

    <div class="formgrid grid m-2">
      <div class="field col-12">
        <label for="groupinitial">
          Client Group Initial<span style="color: rgb(60, 137, 246);font-size:9px !important;"> (Max 20
            chars) </span><span class="required-label">*</span>
        </label>
        <input type="text" class="form-control" placeholder="Enter Initial" id="groupinitial"
          formControlName="groupinitial" required name="groupinitial" pInputText>
        <span class="errormessage"
          *ngIf="groupForm.get('groupinitial').invalid && (groupForm.get('groupinitial').dirty || groupForm.get('groupinitial').touched)">
          {{getErrorMessage(groupForm ,validation_message,'groupinitial')}}
        </span>
      </div>
    </div>


    <div class="formgrid grid m-2" *ngIf="isEdit">
      <div class="field col-12">
        <label for="activeflag"> Active Flag </label>
        <p-dropdown [options]="activeFlag" id="activeflag" [filter]="true" appendTo="body" name="activeflag"
          optionLabel="labelname" optionValue="value" placeholder="Select Flag" [resetFilterOnHide]="true"
          formControlName="activeflag"></p-dropdown>
        <span class="errormessage" *ngIf="groupForm.get('activeflag').invalid && groupForm.get('activeflag').touched ">
          {{getErrorMessage(groupForm ,validation_message,'activeflag')}}
        </span>
      </div>
    </div>
  </form>
</div>

<div class="custom-dialog-footer">
  <div class="mt-1"></div>
  <p-button class="m-1" label="Close" styleClass="customeclose"
    (click)="closemodal(groupForm,this.ref,'Are you sure you want to close?')"></p-button>
  <p-button class="m-1" *ngIf="!onlyView" label="{{saveTitle}}" styleClass="customesave"
    (click)="addClientGroup()"></p-button>
  <div class="mt-1"></div>
</div>